export const initialRequestParams = () => ({
  meeting_id: '',
  agency_id: '',
  submission_status_left_id: '',
  submission_status_right_id: '',
})
